




































































































































































































import { Vue } from "vue-property-decorator";
import AppFiltres from "@/components/app-filtres/main.vue";
import AppSubHeader from "./app-subheader.vue";
import { PaletteDocument } from "@/models/PaletteDocument";
import { VieQuotidienneDocuments } from "@/models/VieQuotidienneDocument";
import { utils } from "@/util";
import AppTimer from "@/components/app-timer.vue";
import appDatepicker from "@/components/app-datepicker.vue";
import { FiltreScolarite } from "@/models/_FiltresScolarite";
import { FiltrePointage } from "@/models/_FiltresPointage";

export default Vue.extend({
  components: {
    AppFiltres,
    AppTimer,
    appDatepicker,
    AppSubHeader,
  },
  mounted(){
    this.filtredTempsAccueil = (this.filtrePointage as FiltrePointage)
      .getListTemps()
      .map((temps: any) => temps.getId());
    if (this.dateTimeChanged !== "") {
      this.dateTime = this.dateTimeChanged as string;
    }
  },
  data() {
    return {
      showFiltresMenu: false,
      showModal: false,
      selectedRegim: [] as Array<VieQuotidienneDocuments>,
      filtreActive: [] as Array<String>,
      filtredTempsAccueil: [] as Array<number>,
      dateTime: "",
    };
  },
  methods: {
    undoLastAction() {
      console.log("Last action was ", this.lastAction);
      this.$emit("undo-lastaction");
    },
    defaultLogo(event: any) {
      if (event){
        event.target.src = require(`@/assets/inoe-logo/Logo_iNoe.svg`);
      }
    },
    filtres(event: any) {
      if (
        !this.filtreActive.includes(event.filtre) &&
        event.filtre !== "prenom"
      ) {
        this.filtreActive.push(event.filtre);
      }
      if (event.filtre === "temps") this.filtredTempsAccueil = event.value;
      this.$emit("filtres", event);
    },
    closeFiltres(event: any) {
      if (event === "all") {
        this.filtreActive = [];
        this.filtredTempsAccueil = (this.filtrePointage as FiltrePointage)
          .getListTemps()
          .map((temps: any) => temps.getId());
        this.$emit("close-filtre", event);
      } else {
        if (this.filtreActive.includes(event)) {
          if (event === "temps") {
            this.filtredTempsAccueil = [];
            this.filtredTempsAccueil = (this.filtrePointage as FiltrePointage)
              .getListTemps()
              .map((temps: any) => temps.getId());
          }

          let index = this.filtreActive.indexOf(event);
          this.filtreActive.splice(index, 1);
          this.$emit("close-filtre", event);
        }
      }
    },
    selectRegim(regim: VieQuotidienneDocuments) {
      if (this.selectedRegim.includes(regim)) {
        let index = this.selectedRegim.indexOf(regim);
        this.selectedRegim.splice(index, 1);
      } else {
        this.selectedRegim.push(regim);
      }
    },
    clearRegim() {
      this.selectedRegim = [];
      this.$emit("close-filtre", "regim");
    },
    pushRegim() {
      let params = {
        filtre: "regim",
        value: this.selectedRegim,
      };
      if (this.selectedRegim.length < 1) {
        this.clearRegim();
      } else {
        this.$emit("filtres", params);
      }
      (this.$refs.regimdropdown as Vue & { hide: (b: boolean) => any }).hide(
        true
      );
    },
    getImgFromIntitule(regim: string): any {
      if (regim === "Autre")
        return require(`@/assets/information/regime/REG_ALIM_AUTRE_LISTE_NOM.svg`);
      else if (regim === "Sans porc")
        return require(`@/assets/information/regime/REG_ALIM_SANS_PORC.svg`);
      else if (regim === "Sans viande")
        return require(`@/assets/information/regime/REG_ALIM_SANS_VIANDE.svg`);
      else if (regim === "Végétarien")
        return require(`@/assets/information/regime/REG_ALIM_VEGETARIEN.svg`);
      else if (regim === "Sans gluten")
        return require(`@/assets/information/regime/REG_ALIM_SANS_GLUTEN.svg`);
      else if (regim === "PAI")
        return require(`@/assets/information/regime/REG_ALIM_PAI.svg`);
      else if (regim === "Sans régime")
        return require(`@/assets/information/regime/REG_ALIM_DEFAUT_STANDARD.svg`);
      else if (regim === "Sans poisson")
        return require(`@/assets/information/regime/REG_ALIM_SANS_POISSON.svg`);
      else
        return require(`@/assets/information/regime/REG_ALIM_AUTRE_LISTE_NOM.svg`);
    },
    countRegimAlim(regim: string) {
      let count = 0;
      this.countRegim.forEach((element: any) => {
        if (element["regim_id"] === regim) count += element["count"];
      });
      return count;
    },
    totalRegimCount(): number {
      let total: number = this.countRegim.reduce(
        (acc: number, item: any) => acc + item.count,
        0
      );
      return total;
    },
    confReservation() {
      this.$emit("conf-reserv");
    },
    getSrc(base64: string) {
      let extension = utils.GetFileExtensionFromBase64(base64);
      if (extension === "-1")
        return require(`@/assets/inoe-logo/Logo_iNoe.svg`);
      else return `data:image/${extension};base64,${base64}`;
    },
    clickDate() {
      this.showModal = true;
    },
    closeDatePicker() {
      this.showModal = false;
    },
    emitDateTime(event: any) {
      this.$emit("date-time", event);
      this.showModal = false;
      this.dateTime = event;
      this.closeFiltres("all");
    },
    checkChangeDate() {
      if (this.dateTime === "") {
        return false;
      } else if (
        this.dateTime === utils.getCurrentTimeNow().format("YYYY-MM-DD")
      ) {
        return false;
      } else {
        return true;
      }
    },
    selectChange(event: number) {
      this.$emit("change-page-size", event);
    },
  },
  computed: {
    filtresIcon() {
      let srcOff = require(`@/assets/header/BANDEAU_FILTRE_DESACTIVE.svg`);
      let srcOn = require(`@/assets/header/BANDEAU_FILTRE_ACTIVE.svg`);
      if (this.showFiltresMenu) {
        return srcOn;
      } else {
        return srcOff;
      }
      //return this.showFiltresMenu ? srcOn : srcOff;
    },
  },
  props: {
    hasFilter: {
      type: Boolean,
      default: false,
    },
    hasDynamicDate: {
      type: Boolean,
      default: false,
    },
    hasSubHeader: {
      type: Boolean,
      default: false,
    },
    filtreScolarite: {
      type: FiltreScolarite,
      default: () => new FiltreScolarite(),
    },
    filtrePointage: {
      type: FiltrePointage,
      default: () => new FiltrePointage(),
    },
    listRegim: {
      type: Array,
      default: () => [],
    },
    vieQuoRegimeAli: {
      type: Array,
      default: () => [],
    },
    countRegim: {
      type: Array,
      default: () => [],
    },
    listVille: {
      type: Array,
      default: () => [],
    },
    lastAction: {
      type: Object,
      default: () => {},
    },
    currentEtabLogo: {
      type: String,
      default: " ",
    },
    currentEtabName: {
      type: String,
      default: " ",
    },
    currentActivite: {
      type: Object,
      default: () => {},
    },
    dateTimeChanged: {
      type: String,
      default: "",
    },
    updateOnlineStatus: {
      type: Boolean,
      default: true,
    },
    isIndividuDuJours: {
      type: Boolean,
      default: true,
    },
    selectedPageSize: {
      type: Number,
      default: 999,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    maxPage: {
      type: Number,
      default: 1,
    },
    paletteEnCours:{
      type: PaletteDocument
    }
  },
  watch: {
    filtrePointage: {
      handler(val: FiltrePointage) {
        this.filtredTempsAccueil = (this.filtrePointage as FiltrePointage)
          .getListTemps()
          .map((temps: any) => temps.getId());
      },
      deep: true,
    },
  },
});
